import { drawer } from "./drawer";
import { tabs } from "./tabs";
import { generalInfo } from "./sections/general-info";
import { pricing } from "./sections/pricing";
import { stock } from "./sections/stock";
import { fiscalData } from "./sections/fiscal-data";
import { mountableSteps } from "./sections/mountable-steps";
import { comingSoon } from "./components/coming-soon";
import { productTypeSelect } from "./components/product-type-select";
import { formActions } from "./form-actions";
import { validation } from "./validation";
import { tooltips } from "./tooltips";
import { bars } from "./sections/bars";
import { technicalSheet } from "./sections/production-rule";

export const productForm = {
	drawer,
	tabs,
	sections: {
		generalInfo,
		pricing,
		stock,
		fiscalData,
		bars,
		mountableSteps,
		technicalSheet,
	},
	components: {
		comingSoon,
		productTypeSelect,
	},
	formActions,
	validation,
	tooltips,
};

export type productFormTranslations = typeof productForm;
